import { useLogto } from "@logto/react";
import axios, { Axios } from "axios";
import { useEffect } from "react";
import { logoutUnauthenticatedUser } from "./helpers/apiRequestAuthHelper";
// import { logtoClient } from "./logto";

export const axiosClient = axios.create({
  baseURL: import.meta.env["VITE_APP_BASE_URL"],
});
export const axiosQaClient = axios.create({
  baseURL: import.meta.env["VITE_APP_QA_BASE_URL"],
});
export const authAxiosClient = axios.create({
  baseURL: import.meta.env["VITE_APP_BASE_URL"],
  // withCredentials: true,
});
export const slaAxiosClient = axios.create({
  baseURL: import.meta.env["VITE_APP_SLA_BASE_URL"],
});

export const useSetInterceptorToken = () => {
  const { getAccessToken, signOut } = useLogto();

  useEffect(() => {
    const authRequestInterceptor = authAxiosClient.interceptors.request.use(
      async (req) => {
        const accessToken = await getAccessToken(
          import.meta.env.VITE_APP_BASE_URL,
        );

        req.headers["Authorization"] = `Bearer ${accessToken}`;
        return req;
      },
      function (error) {
        return Promise.reject(error);
      },
    );

    const axiosRequestInterceptor = axiosClient.interceptors.request.use(
      async (req) => {
        const accessToken = await getAccessToken(
          import.meta.env.VITE_APP_BASE_URL,
        );
        if (!accessToken) {
          logoutUnauthenticatedUser(signOut);
          return req;
        }

        req.headers["Authorization"] = `Bearer ${accessToken}`;

        return req;
      },
      function (error) {
        return Promise.reject(error);
      },
    );

    const axiosResponseInterceptor = axiosClient.interceptors.response.use(
      async (res) => {
        if (res.status === 401) {
          logoutUnauthenticatedUser(signOut);
        }
        return res;
      },
      async function (error) {
        if (error?.response?.status === 401) {
          logoutUnauthenticatedUser(signOut);
        }
        if (error.response && [301, 302].includes(error.response.status)) {
          const redirectUrl = error.response.headers.location;
          return axiosClient.get(redirectUrl);
        }
        return Promise.reject(error);
      },
    );

    const slaRequestInterceptor = slaAxiosClient.interceptors.request.use(
      async (req) => {
        const accessToken = await getAccessToken(
          import.meta.env.VITE_APP_BASE_URL,
        );
        if (!accessToken) {
          logoutUnauthenticatedUser(signOut);
          return req;
        }

        req.headers["Authorization"] = `Bearer ${accessToken}`;

        return req;
      },
      function (error) {
        return Promise.reject(error);
      },
    );

    const slaResponseInterceptor = slaAxiosClient.interceptors.response.use(
      async (res) => {
        if (res.status === 401) {
          logoutUnauthenticatedUser(signOut);
        }
        return res;
      },
      async function (error) {
        if (error?.response?.status === 401) {
          logoutUnauthenticatedUser(signOut);
        }
        return Promise.reject(error);
      },
    );

    const authResponseInterceptor = authAxiosClient.interceptors.response.use(
      async (res) => {
        if (res.status === 401) {
          // logoutUnauthenticatedUser(res);
        }
        return res;
      },
      async function (error) {
        if (error?.response?.status === 401) {
          // logoutUnauthenticatedUser(error);
        }
        return Promise.reject(error);
      },
    );

    return () => {
      authAxiosClient.interceptors.request.eject(authRequestInterceptor);
      axiosClient.interceptors.request.eject(axiosRequestInterceptor);
      axiosClient.interceptors.response.eject(axiosResponseInterceptor);
      authAxiosClient.interceptors.response.eject(authResponseInterceptor);
      slaAxiosClient.interceptors.request.eject(slaRequestInterceptor);
      slaAxiosClient.interceptors.response.eject(slaResponseInterceptor);
    };
  }, [getAccessToken]);

  return [];
};

// authAxiosClient.interceptors.request.use(
//   (req) => {
//     const accessToken = getAccessToken();
//     req.headers["Authorization"] = `Bearer ${accessToken}`;
//     return req;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

// axiosClient.interceptors.request.use(
//   (req) => {
//     const accessToken = getAccessToken();
//     req.headers["Authorization"] = `Bearer ${accessToken}`;

//     return req;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

// axiosClient.interceptors.response.use(
//   async (res) => {
//     if (res.status === 401) {
//       // const response = await reAuthenticateUser(res);
//       // if (response && response !== null) {
//       //   return axiosClient.request(response);
//       // }
//     }
//     return res;
//   },
//   async function (error) {
//     if (error?.response?.status === 401) {
//       // const response = await reAuthenticateUser(error);
//       // if (response && response !== null) {
//       //   return axios.request(response);
//       // }
//     }
//     console.log(error);
//     if (error.response && [301, 302].includes(error.response.status)) {
//       const redirectUrl = error.response.headers.location;
//       console.log(error.response);
//       return axiosClient.get(redirectUrl);
//     }
//     return Promise.reject(error);
//   }
// );

// authAxiosClient.interceptors.response.use(
//   async (res) => {
//     if (res.status === 401) {
//       // const response = await reAuthenticateUser(res);
//       // if (response && response !== null) {
//       //   return authAxiosClient.request(response);
//       // }
//     }
//     return res;
//   },
//   async function (error) {
//     if (error?.response?.status === 401) {
//       // const response = await reAuthenticateUser(error);
//       // if (response && response !== null) {
//       //   return axios.request(response);
//       // }
//     }
//     return Promise.reject(error);
//   }
// );
